<ion-item lines="none" class="cus-select-text, truncate" *ngIf="selected.length">
  <span class="truncate">{{selectedItemsString() | capitalize : shouldCapitalize() }}</span>
</ion-item>
<ion-modal [isOpen]="isOpen" [backdropDismiss]="false">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="clearOrSelect()" *ngIf="(isMultiple() || buttonName === clearString )">{{buttonName}}</ion-button>
        </ion-buttons>
        <ion-title> {{getTitle()}} </ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="cancel()">Cancel</ion-button>
        </ion-buttons>
      </ion-toolbar>
      <ion-toolbar class="ion-padding-top">
        <ion-searchbar #cusSearchbar [debounce]="100" (ionChange)="filter($any($event))" (ionClear)="filterClear()" how-clear-button="always" #searchbarComponent [(ngModel)]="searchText" ></ion-searchbar>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-item-divider *ngIf="getInactiveCounter()>0">Active</ion-item-divider>
      <ng-container *ngFor="let item of filtered">
        <ng-container *ngIf="item.active==1 || item.active == undefined">
          <ion-item [disabled]="item.active==0&&!isInactiveSelectable()">
            <ion-checkbox slot="start" [(ngModel)]="item.selected" (ionChange)="itemSelected(item)"></ion-checkbox>
            {{ leaf(item) | capitalize : shouldCapitalize() }}
          </ion-item>
        </ng-container>
      </ng-container>
      <br/>
      <ion-item-divider *ngIf="getInactiveCounter() > 0">Inactive</ion-item-divider>
      <ng-container *ngFor="let item of filtered">
        <ng-container *ngIf="item.active==0">
          <ion-item [disabled]="item.active==0&&!isInactiveSelectable()">
            <ion-checkbox slot="start" [(ngModel)]="item.selected" (ionChange)="itemSelected(item)"></ion-checkbox>
            <span [ngClass]="{'inactive-text': item.active === 0}">{{ leaf(item) + (item.active===0? " (inactive)":"")}}</span>
          </ion-item>
        </ng-container>
      </ng-container>
    </ion-content>
    <ion-footer class="ion-padding">
      <ion-button expand="block" fill="outline" (click)="select()">Save</ion-button>
    </ion-footer>
  </ng-template>
</ion-modal>
